(function () {
    'use strict';

    angular
        .module('app')
        .controller('GamesEditController', GamesEditController);

    GamesEditController.$inject = ['debug', '$stateParams', 'i18n', 'API',];

    function GamesEditController(debug, $stateParams, i18n, API) {
        var vm = this;
        vm.tag = $stateParams.tag;
        vm.isSaving = false;
        vm.save = save;
        vm.game = {
            translations: {},
        };
        vm.loadingState = {
            gameIsLoading: false
        };

        activate();

        function activate() {
            loadGame();
        }

        function loadGame() {
            vm.loadingState.gameIsLoading = true;
            API.Game.get({ tag: vm.tag, }).$promise.then(function (response) {
                debug.log(response);
                angular.extend(vm.game, response);
                vm.loadingState.gameIsLoading = false;
            }, function (response) {
                debug.log(response);
            });
        }

        function save() {
            if (vm.isSaving) {
                return;
            }

            vm.isSaving = true;

            API.Game.update({}, vm.game).$promise.then(function (response) {
                if (response.tag) {
                    angular.extend(vm.game, response);
                    window.toast({ message: i18n.get('SAVED'), autoRemoveTime: 5000, type: 'success' });
                }
            }, function () {
            })
            .finally(function() {
                vm.isSaving = false;
            });
        }
    }
})();